export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#111111] text-[#E9ECEF] overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 pt-24 md:pt-32 pb-10">
        <div className="grid grid-cols-12 gap-12 lg:gap-16">
          <div className="col-span-12 md:col-span-4">
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-[#D62828]" />
              <span className="text-[11px] uppercase tracking-[0.28em] text-[#E9ECEF]/60">
                Blude TechX LLP
              </span>
            </div>
            <p className="mt-6 font-serif-italic italic text-2xl md:text-3xl leading-snug max-w-md text-[#E9ECEF]/85">
              Healthcare Unified for Everyone.
            </p>
          </div>

          <FooterCol
            title="Headquarters"
            rows={["Madurai, Tamil Nadu", "Version One, South India", "Founded 2025"]}
          />
          <FooterCol
            title="Address"
            rows={["Ram Nagar, Bama Nagar.", "Madurai- 625017,", "TamilNadu, India"]}
          />
          <FooterCol
            title="Contact"
            rows={[
              <a key="mail" data-testid="footer-mail" href="mailto:hello@bludetechx.com" className="hover:text-[#D62828] transition-colors">hello@bludetechx.com</a>,
              <a key="careers" data-testid="footer-careers" href="mailto:careers@bludetechx.com" className="hover:text-[#D62828] transition-colors">careers@bludetechx.com</a>,
              <a key="phone1" href="tel:+919087977782" className="hover:text-[#D62828] transition-colors">+91 9087977782</a>,
              <a key="phone2" href="tel:+919087977783" className="hover:text-[#D62828] transition-colors">+91 9087977783</a>,
            ]}
          />
        </div>

        {/* Wordmark */}
        <div className="mt-20 md:mt-28 overflow-hidden">
          <svg
            data-testid="footer-wordmark"
            viewBox="0 0 1000 200"
            preserveAspectRatio="xMidYMid meet"
            className="w-full h-auto select-none block"
            aria-label="Blude TechX"
          >
            <text
              x="500"
              y="170"
              textAnchor="middle"
              textLength="990"
              lengthAdjust="spacingAndGlyphs"
              fill="#E9ECEF"
              style={{
                fontFamily: "'Cabinet Grotesk', 'Manrope', sans-serif",
                fontWeight: 800,
                fontSize: "220px",
                letterSpacing: "-4px",
              }}
            >
              BLUDE<tspan fill="#D62828" dx="8">.</tspan><tspan dx="8">TECHX</tspan>
            </text>
          </svg>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12px] text-[#E9ECEF]/55">
          <span data-testid="footer-copy">
            {"\u00A9"} {new Date().getFullYear()} Blude TechX LLP. All rights reserved.
          </span>
          <span>
            Built in India. For the future of healthcare.
          </span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, rows }) {
  return (
    <div className="col-span-6 md:col-span-2">
      <div className="text-[11px] uppercase tracking-[0.28em] text-[#E9ECEF]/55">
        {title}
      </div>
      <ul className="mt-6 space-y-3 text-[14px] leading-relaxed text-[#E9ECEF]/85">
        {rows.map((r, i) => (
          <li key={i}>{r}</li>
        ))}
      </ul>
    </div>
  );
}
